import { memo } from 'react';

import { cn } from '../../lib/css/className/className';
import { SkinRole } from '../../lib/skin/getColorSkin/generated/types';
import { getColorSkin } from '../../lib/skin/getColorSkin/getColorSkin';

import './TextHighlighter.css';

import type { TextHighlighterColor, TextHighlighterProps } from './types';
const cls = cn('TextHighlighter');

const skinMap: Record<TextHighlighterColor, SkinRole> = {
    success: 'success-lc',
    warning: 'warning-lc',
    error: 'error-lc',
    info: 'info-lc',
    message: 'message-lc',
};

/**
 * Подсветка части текста: ведёт себя как инлайн-контент,
 * удобно в таблицах и длинных строках
 *
 * Тип `wrapper` (значение по умолчанию) — как плашка: целое слово, фраза,
 * несколько строк (в том числе с переносом через `<br />`)
 *
 * Тип `selection` — как выделение. Нужен, когда подсвечивается
 * часть слова (поиск, совпадение, подсказка в середине слова); с `wrapper` выделеная
 * аналогично подстрока будет визуально отрываться от основного текста
 *
 * Цвет — семантические роли темы (`success`, `warning`, `error`, `info`, `message`)
 *
 * Пустой `children` — компонент вернёт `null`
 */
export const TextHighlighter = memo<TextHighlighterProps>(function TextHighlighter({
    children,
    className,
    'data-testid': dataTestId,
    color = 'info',
    type = 'wrapper',
}) {
    const colorSkinClass = getColorSkin(skinMap[color], {});

    if (!children) {
        return null;
    }

    return (
        <span className={cls('wrapper', { type })}>
            <span className={cls({ color, type }, [className, colorSkinClass])} data-testid={dataTestId}>
                {children}
            </span>
        </span>
    );
});
